import axios, { parseCursor } from '@/base/api/axios'

export default {
  async create (data) {
    return (await axios.post('/api/issues/', data)).data
  },

  async get (id) {
    return (await axios.get(`/api/issues/${id}/`)).data
  },

  async assignMediator (issueId) {
    return (await axios.post(`/api/issues/${issueId}/mediator/`)).data
  },

  async unassignMediator (issueId) {
    return (await axios.delete(`/api/issues/${issueId}/mediator/`)).data
  },

  async decide (data) {
    return (await axios.post('/api/decisions/', data)).data
  },

  async list (filter) {
    const response = (await axios.get('/api/issues/', { params: filter })).data
    return {
      ...response,
      next: parseCursor(response.next),
      results: response.results,
    }
  },

  async conversation (issueId) {
    return (await axios.get(`/api/issues/${issueId}/conversation/`)).data
  },

  async vote (issueId, listOfVotes) {
    await axios.post(`/api/issues/${issueId}/vote/`, listOfVotes)
  },

  async deleteVote (issueId) {
    await axios.delete(`/api/issues/${issueId}/vote/`)
  },
}
